import React, { useEffect, useState } from "react";
import { Textarea } from "../../../components/form-inputs/inputs";

const SearchInput = (props) => {
    const [upcValues, setUpcValues] = useState("");

    useEffect(() => {
        if (props.resetUpcValues) {
            setUpcValues("");
        }
    }, [props.resetUpcValues]);

    const onSearch = () => {
        props.searchUpcs(upcValues);
    };

    return (
        <div>
            <Textarea
                label="Upc(s)"
                value={upcValues}
                updateOnChange={(name, value) => {
                    setUpcValues(value);
                }}
            />
            <button className="button -primary -full" onClick={onSearch}>
                Search UPCs
            </button>
        </div>
    );
};

export default SearchInput;
